import React, { FC, useEffect } from 'react'
import GreetingsBanner from './GreetingsBanner'
import MaintenanceAlert from './MaintenanceAlert'
import MenusLinks from './MenusLinks'

import { useToast } from '@celebration/react'

const Home: FC = (): React.ReactElement => {

  const { openToast } = useToast()

  useEffect(() => {
    const profileChanged = sessionStorage.getItem('profileChanged')

    if (profileChanged === 'true') {
      openToast({
        title: 'Perfil alterado',
        description: 'Perfil do usuário alterado com sucesso',
        type: 'positive',
      })

      sessionStorage.removeItem('profileChanged')
    }
  }, [openToast])

  return (
    <>
      <GreetingsBanner />
      <MaintenanceAlert />
      <MenusLinks />
    </>
  )
}

export default Home
